var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-cart__heading"},[_c('div',{staticClass:"overlay-cart__close",on:{"click":function($event){return _vm.$store.commit('overlay/SET_OVERLAY', '')}}},[_vm._m(0)]),_vm._v(" "),_c('h3',{staticClass:"overlay-cart__title"},[_vm._v("\n    Your cart ("+_vm._s(_vm.count)+")\n  ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i'),_c('i')])
}]

export { render, staticRenderFns }